<template>
	<div>
		<div class="content">
			<!-- 轮播图 -->
			<div id="carousel">
				<el-carousel height="15.625rem" arrow="never" indicator-position="none" v-if="url.length >0">
					<el-carousel-item v-for="item in url" :key="item" style="width: 100%;height: 100%;">
						<el-image style="100%; height: 100%" :src="item.indexOf('http') == -1?imgUrl+item:item"
							fit="cover"></el-image>
					</el-carousel-item>
				</el-carousel>
				<div v-else>
					<img src="../../common/img/nothing.png" alt="" style="width: 8.5rem;height: 7.9375rem;">
				</div>
			</div>
			<!-- 轮播图 -->
		</div>
	</div>
</template>
<script>
	import {
		apiurl,
		imgurl
	} from '../../common/js/baseApi.js'
	import axios from 'axios'
	export default {
		components: {},
		data() {
			return {
				url: [],
				pId: '', // 用户id
				value1: 0,
				imgUrl: imgurl
			}
		},
		computed: {},
		watch: {},
		methods: {
			getRiskFour() {
				axios.get(apiurl + '/risk/getRiskFour', {
						params: {
							pId: this.pId
						}
					})
					.then(data => {
						if (data.data.code !== 1) {
							return
						}
						let res = data.data.data
						res.forEach((item) => {
							this.url.push(imgurl + item.fileUrl)
						})
					})
					.catch(err => {

					})
			}
		},
		created() {},
		mounted() {
			var url = window.location.search;
			var theRequest = new Object();
			if (url.indexOf("?") != -1) {
				var str = url.split('?')[1];
				var strs = str.split("&");
				for (var i = 0; i < strs.length; i++) {
					theRequest[strs[i].split("=")[0]] = (strs[i].split("=")[1]);
				}
			}
			this.pId = theRequest.pId
			this.getRiskFour()
		},
		beforeCreate() {},
		beforeMount() {},
		beforeUpdate() {},
		updated() {},
		beforeDestroy() {},
		destroyed() {},
		activated() {},
	}
</script>
<style lang='scss' scoped>
	.content {
		width: 27.125rem;
		height: 15.625rem;

		#carousel {
			width: 100%;
			height: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/rightTop/index.vue